module.exports = __webpack_public_path__ + "h5/img/funv-nav2.95c0bcbe.png";